export var ELayout = /* @__PURE__ */ ((ELayout2) => {
  ELayout2["HUG"] = "hug";
  ELayout2["FILL"] = "fill";
  return ELayout2;
})(ELayout || {});
export var EVariant = /* @__PURE__ */ ((EVariant2) => {
  EVariant2["DEFAULT"] = "default";
  EVariant2["PILL"] = "pill";
  return EVariant2;
})(EVariant || {});
